import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="48" height="48" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M31.6 15.4L15.4 31.6m0-16.2l16.3 16.3" stroke="currentColor" fill="none" /></svg>;